"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
exports.default = `<svg id="machine-icon-generic" viewBox="0 0 540 540" xmlns="http://www.w3.org/2000/svg">
  <path d="m270 240v289l202-115v-289z" fill="#808080" />
  <path d="m67 125 203 115v289l-203-115z" fill="#999" />
  <path d="m270 240v243l202-115v-242z" fill="#b7b7b7" />
  <path d="m270 18 202 107-202 115-203-115z" fill="#ececec" />
  <path d="m67 125 203 115v243l-203-115z" fill="#d8d8d8" />
</svg>`;
//# sourceMappingURL=machine-icon-generic.js.map